import * as React from "react";
import Box from "@mui/material/Box";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { Instance } from "@popperjs/core";
import { Color, ColorMono, Typography } from "kvweb-ui";
import { styled } from "@mui/material";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} componentsProps={{ tooltip: { className: className } }} />
))(`
    color: ${ColorMono["color-white"]};
    background-color: ${Color["black-750"]};
    border-radius: 8px;
`);

interface IAnchorElTooltipsProps {
  children: React.ReactNode;
  sub: string;
  placement:
    | "top"
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | undefined;
  textCenter?: boolean
}
export default function AnchorElTooltips({
  sub,
  children,
  placement = "top",
  textCenter = false
}: IAnchorElTooltipsProps) {
  const positionRef = React.useRef<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const popperRef = React.useRef<Instance>(null);
  const areaRef = React.useRef<HTMLDivElement>(null);

  const handleMouseMove = (event: React.MouseEvent) => {
    positionRef.current = { x: event.clientX, y: event.clientY };

    if (popperRef.current != null) {
      popperRef.current.update();
    }
  };

  return (
    <CustomTooltip
      title={<TooltipContent textCenter={textCenter || false} content={sub} />}
      placement={placement}
      arrow
      sx={{
        "& .MuiTooltip-arrow::before": {
          backgroundColor: Color["black-750"],
        },
        fontSize: "14px",
        lineHeight: "20px",
        display: "flex",
        alignItems: "center",
      }}
      PopperProps={{
        popperRef,
        anchorEl: {
          getBoundingClientRect: () => {
            return new DOMRect(
              positionRef.current.x,
              areaRef.current!.getBoundingClientRect().y,
              0,
              0
            );
          },
        },
      }}
    >
      <Box ref={areaRef} onMouseMove={handleMouseMove} display="flex">
        {children}
      </Box>
    </CustomTooltip>
  );
}

function TooltipContent({ content, textCenter }: { content: string, textCenter: boolean }) {
  return <Typography textType="text14R" textAlign={textCenter ? 'center' : 'left'}>{content}</Typography>;
}
